<template>
    <div>
        <v-container class="pt-0 pb-5">
            <v-row>
                <v-col>
                    <div class="pa-2 rounded elevation-1 bg-white">
                        <v-btn color="primary-dark" @click="$router.push({ name: 'Administration' })" density="compact"
                            variant="outlined">
                            <v-icon left>mdi-arrow-left</v-icon>
                            Retour
                        </v-btn>
                        <div class="text-h6 mt-2 mb-4">Inscriptions multiparcours à {{ mainStore.module.nom}}</div>

                        <div v-if="multi">
                            <div>Il y a {{ multi.nb_multi_inscrits }} participants qui sont inscrits à au moins deux parcours.</div>
                            <v-simple-table>
                                <template v-slot:default>
                                    <thead>
                                        <tr>
                                            <th class="text-left">Nom</th>
                                            <th class="text-left">Prénom</th>
                                            <th class="text-left">Parcours</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(inscrit,index) in multi.inscrits" :key="index">
                                            <td>{{ inscrit.nom }}</td>
                                            <td>{{ inscrit.prenom }}</td>
                                            <td><v-chip density="compact" class="ma-1" v-for="(course,index_course) in inscrit.courses" :key="index_course">{{ course }}</v-chip></td>
                                        </tr>
                                    </tbody>
                                </template>
                            </v-simple-table>
                        </div>
                    </div>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import AdminService from "@/services/admin.service";


export default {
    components: {  },
    data() {
        return {
            multi : null
        };
    },
    computed: {
        ...mapStores(useMainStore),
    },
    async created() {
        let request = await AdminService.getListInscritsMultiParcours(this.mainStore.module.id);
        if (request) {
            this.multi = request;
        }

    },
};
</script>

<style lang="scss" scoped></style>